"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/deviceControler',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";

    var DeviceController = function () {
        function DeviceController() {
            _classCallCheck(this, DeviceController);
        }

        _createClass(DeviceController, [{
            key: "getSerialNumbers",
            value: function getSerialNumbers(data) {
                return abortingRequest.send('/api/devices/GetSerialNumbers', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getImeis",
            value: function getImeis(data) {
                return abortingRequest.send('/api/devices/GetImeis', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPhoneNumbers",
            value: function getPhoneNumbers(data) {
                return abortingRequest.send('/api/devices/GetPhoneNumbers', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDeviceByBoxId",
            value: function getDeviceByBoxId(data) {
                return abortingRequest.send('/api/devices/GetDeviceByBoxId', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDeviceDetailsHistory",
            value: function getDeviceDetailsHistory(data) {
                return abortingRequest.send('/api/devices/GetDeviceDetailsHistory', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAllocations",
            value: function getAllocations(data) {
                return abortingRequest.send('/api/devices/GetAllocations', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAvailableOwners",
            value: function getAvailableOwners() {
                return abortingRequest.send('/api/devices/GetAvailableOwners', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getAvailableLocations",
            value: function getAvailableLocations() {
                return abortingRequest.send('/api/devices/GetAvailableLocations', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getAvailableEnvironments",
            value: function getAvailableEnvironments() {
                return abortingRequest.send('/api/devices/GetAvailableEnvironments', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getAvailableStatuses",
            value: function getAvailableStatuses() {
                return abortingRequest.send('/api/devices/GetAvailableStatuses', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getBatteryStatus",
            value: function getBatteryStatus(data) {
                return abortingRequest.send('/api/devices/GetBatteryStatus', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getData",
            value: function getData(data) {
                return abortingRequest.send('/api/devices/GetData', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDataForDate",
            value: function getDataForDate(data) {
                return abortingRequest.send('/api/devices/GetDataForDate', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPacketsForDate",
            value: function getPacketsForDate(data) {
                return abortingRequest.send('/api/devices/GetPacketsForDate', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getRawPacketsForDate",
            value: function getRawPacketsForDate(data) {
                return abortingRequest.send('/api/devices/GetRawPacketsForDate', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLatestPacket",
            value: function getLatestPacket(data) {
                return abortingRequest.send('/api/devices/GetLatestPacket', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getSosForDate",
            value: function getSosForDate(data) {
                return abortingRequest.send('/api/devices/GetSosForDate', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getCommunicationsStatus",
            value: function getCommunicationsStatus(data) {
                return abortingRequest.send('/api/devices/GetCommunicationsStatus', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "hibernateDevice",
            value: function hibernateDevice(data) {
                return abortingRequest.send('/api/devices/HibernateDevice', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "wakeUpDevice",
            value: function wakeUpDevice(data) {
                return abortingRequest.send('/api/devices/WakeUpDevice', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getHibernatedDevices",
            value: function getHibernatedDevices() {
                return abortingRequest.send('/api/devices/GetHibernatedDevices', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getLastTimeChargerInserted",
            value: function getLastTimeChargerInserted(data) {
                return abortingRequest.send('/api/devices/GetLastTimeChargerInserted', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLastTimeFullyCharged",
            value: function getLastTimeFullyCharged(data) {
                return abortingRequest.send('/api/devices/GetLastTimeFullyCharged', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getCurrentChargePercentage",
            value: function getCurrentChargePercentage(data) {
                return abortingRequest.send('/api/devices/GetCurrentChargePercentage', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updateDevice",
            value: function updateDevice(data) {
                return abortingRequest.send('/api/devices/UpdateDevice', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updateDevices",
            value: function updateDevices(data) {
                return abortingRequest.send('/api/devices/UpdateDevices', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "deserializePacket100",
            value: function deserializePacket100(data) {
                return abortingRequest.send('/api/devices/DeserializePacket100', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "rebuildBatteryDataFromPolicyStart",
            value: function rebuildBatteryDataFromPolicyStart(data) {
                return abortingRequest.send('/api/devices/RebuildBatteryDataFromPolicyStart', ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return DeviceController;
    }();

    return new DeviceController();
});
//# sourceMappingURL=deviceControler.js.map;
